/**
 * Internal dependencies
 */
import config from "../../config.json";

export default window[config?.frontend?.globalConfig] || {
	ajax_url: "",
	actions: {},
	texts: {},
	icons: {},
};
